import type { ICatalogData, ILocaleData, ILocaleStringData, IUserData, IUserGroupData } from '@/entities/user';
import type {
  IApiLocaleResponse,
  IApiLocaleStringResponse,
  IPrimeCatalogResponse,
  IPrimeUserGroupResponse,
  IPrimeUserResponse
} from '@/services';

export const mapPrimeUser = (data: Readonly<IPrimeUserResponse>): IUserData => {
  return {
    id: data.id,
    avatarUrl: data.attributes.avatarUrl,
    email: data.attributes.email,
    uiLanguage: data.attributes.uiLocale,
    contentLanguage: data.attributes.contentLocale,
    name: data.attributes.name,
    alias: data.attributes.name,
    title: '',
    timezone: '',
    roles: data.attributes.roles,
    role: data?.user_role,
    pointsEarned: data.attributes.pointsEarned,
    account: data.attributes.fields?.['Account'] || '',
    accountType: data.attributes.fields?.['Account Type'] || ''
  };
};

export const mapPrimeUserGroup = (data: Readonly<IPrimeUserGroupResponse>): IUserGroupData => {
  return {
    id: data.id,
    dateCreated: data.attributes.dateCreated,
    description: data.attributes.description,
    name: data.attributes.name,
    readOnly: data.attributes.readOnly,
    state: data.attributes.state,
    userCount: data.attributes.userCount
  };
};

export const mapPrimeCatalog = (data: Readonly<IPrimeCatalogResponse>): ICatalogData => {
  return {
    id: data.id,
    name: data.attributes.name,
    description: data.attributes.description,
    isDefault: data.attributes.isDefault,
    isInternallySearchable: data.attributes.isInternallySearchable,
    isListable: data.attributes.isListable,
    state: data.attributes.state,
    dateCreated: data.attributes.dateCreated,
    dateUpdated: data.attributes.dateUpdated
  };
};

export const mapLocale = (data: Readonly<IApiLocaleResponse>): ILocaleData => {
  return {
    id: data.id,
    name: data.name,
    locale: data.locale
  };
};

export const mapLocaleString = (data: Readonly<IApiLocaleStringResponse>): ILocaleStringData => {
  return {
    id: data.id,
    value: data.value
  };
};
